import { render, staticRenderFns } from "./ClickOffer.vue?vue&type=template&id=5bd0176c&scoped=true&lang=html&"
import script from "./ClickOffer.vue?vue&type=script&lang=js&"
export * from "./ClickOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0176c",
  null
  
)

export default component.exports